import {
  CheckoutQueryParams,
  DEFAULT_FREQUENCIES,
  DEFAULT_INTELLIGENT_ASK_ONE_TIME_AMOUNTS,
  DEFAULT_INTELLIGENT_ASK_RECURRING_AMOUNTS,
  DonationProps,
  ProgramDesignation,
  SearchSelectOption,
} from '@classy/campaign-page-blocks'
import { ParsedUrlQuery } from 'querystring'
import { overrideDonationBlockPropsByQueryParams } from './overrideDonationBlockPropsByQueryParams'
import { PageConfig } from 'models/pages'

/**
 * Override block props
 */
export const addDonationBlockProps = (
  blockProps: DonationProps,
  queryParams: ParsedUrlQuery,
  campaignId: string,
  orgId: string,
  dcfEnabled: boolean,
  defaultProgramDesignation: ProgramDesignation,
  forwardCheckoutQueryParams: CheckoutQueryParams,
  minDonationAmount: number,
  isCartEnabled: boolean,
  checkoutBaseUrl: string,
  campaignRawCurrencyCode: string,
  initialProgramDesignations: SearchSelectOption[],
  intelligentAskConfig: PageConfig['intelligentAskConfig'],
) => {
  blockProps.campaignId = campaignId
  blockProps.orgId = orgId
  blockProps.dcfEnabled = dcfEnabled
  blockProps.defaultProgramDesignation = defaultProgramDesignation
  blockProps.forwardCheckoutQueryParams = forwardCheckoutQueryParams
  blockProps.minDonationAmount = minDonationAmount
  blockProps.isCartEnabled = isCartEnabled
  blockProps.checkoutBaseUrl = checkoutBaseUrl
  blockProps.currencyCode = campaignRawCurrencyCode
  blockProps.initialProgramDesignations = initialProgramDesignations

  /**
   * When IAA one-time and/or recurring is enabled, the respective amounts cannot
   * be configured by the admin. Therefore, we override block data with hardcoded
   * IAA-specific defaults. This ensures previously saved block data is not used
   * if the IAA fetch times out or fail.
   *
   * Note, we set the IAA-related donation/recurring amounts and frequencies server-side
   * to reduce client bundle size and ensure safe fallback values. Donation.controller
   * handles IAA updates after successfully fetching the IAA config (from APIv2).
   *
   * TODO: CL-48068, merge ontimeEnabled and recurringEnabled into isEnabled
   */

  const iaaOnetimeEnabled = Boolean(intelligentAskConfig?.onetimeEnabled)
  const iaaRecurringEnabled = Boolean(intelligentAskConfig?.recurringEnabled)

  if (iaaOnetimeEnabled || iaaRecurringEnabled) {
    if (iaaOnetimeEnabled) {
      blockProps.donationAmounts = DEFAULT_INTELLIGENT_ASK_ONE_TIME_AMOUNTS
    }

    if (iaaRecurringEnabled) {
      blockProps.recurringAmounts = DEFAULT_INTELLIGENT_ASK_RECURRING_AMOUNTS
    }

    /**
     * If both onetime and recurring are enabled, override with default frequencies.
     * This ensures that if either one-time or monthly was hidden prior to turning
     * on IAA, they are now both visible.
     */
    if (iaaOnetimeEnabled && iaaRecurringEnabled) {
      blockProps.donationFrequencies = DEFAULT_FREQUENCIES
    }
  }

  /**
   * URL query parameter overrides are ignored when IAA is enabled.
   */
  if (!iaaOnetimeEnabled && !iaaRecurringEnabled) {
    // Check if the URL has any query parameter overrides
    overrideDonationBlockPropsByQueryParams(blockProps, queryParams)
  }
}
